module.exports = __webpack_public_path__ + "img/inactive-14.10f8de4d.svg";